import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    getListOfGroupDetails: (idList, searchArgs) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/groups?${encodeParams(
        searchArgs
      )}`,
    getGroupDetails: idGroup =>
      `${baseURL}/api/groups/${encodeURIComponent(idGroup)}`,
    //  Anagraphic fields
    getDynamicFieldsDefinition: filterParams =>
      `${baseURL}/api/fields?${encodeParams(filterParams)}`,
    //  Segmentation
    searchForRecipients: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/search?${encodeParams(
        params
      )}`,
    // Registry
    getRecipient: idRecipient =>
      `${baseURL}/api/recipients/${encodeURIComponent(idRecipient)}`,
    // dynamic fields
    getDynamicFileds: () => `${baseURL}/api/fields`,
    getDynamicFiledsListValue: idList =>
      `${baseURL}/api/fields/list/${encodeURIComponent(idList)}/defaults`,
    getTestsDefault: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/groups/tests/default`,
    lazySearch: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/lazysearch?${encodeParams(params)}`,
    getSmsListSubscriptionCounters: idList =>
      `${baseURL}/api/sms/list/${encodeURIComponent(idList)}/counters`
  }
})(process.env.BERECIPIENT_URL)

export const beRecipientGetSmsListSubscriptionCounters = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsListSubscriptionCounters(idList)
  }).then(extractApiData)
}

export const beRecipientGetListOfGroupDetails = (idList, searchArgs) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfGroupDetails(idList, searchArgs)
  }).then(extractApiData)
}

export const beRecipientGetGroupDetails = idGroup => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getGroupDetails(idGroup)
  }).then(extractApiData)
}

/**
 * @description Get account dynamic fields
 * @param {Object} filterParams
 * @param {boolean} filterParams.isdynamic filter by userdefined as dynamic
 * @returns {Array<Object>} Id,Description,IsDynamic
 */
export const beRecipientGetDynamicFieldsDefinition = filterParams => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getDynamicFieldsDefinition(filterParams)
  }).then(({ data }) => data)
}

/**
 *
 * @param {number} idList The list id
 * @param {Object} params
 * @param {('All'|'Email'|'Sms')} params.channel
 * @param {('Subscribed'|'Pending'|'Unsubscribed')} params.status
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {('Field1'|'Field-n'|'Id'|'Email'|'MobilePrefix'|'MobileNumber'|'MobilePrefixAndNumber'|'SubscriptionDate'|'SubscriptionRequestDate'|'OptoutDate'|'Hash')} params.orderBy
 * @param {boolean} params.orderDescending Order descending
 * @param {boolean} params.evaluateSelectionBlackout Include recipients based on count_sent, date_from and date_to in optin (Email channel only)
 * @param {boolean} params.excludeFields
 *
 * @param {Object} searchConditions
 * @param {Object} searchConditions.DateRanges
 * @param {string} searchConditions.DateRanges.From ISO string date
 * @param {string} searchConditions.DateRanges.To ISO string date
 * @param {Array<number>} searchConditions.IncludeGroups
 * @param {Array<number>} searchConditions.ExcludeGroups
 * @param {Array<Object>} searchConditions.MatchingFields {Id: 0, Value: string}
 * @param {Object} searchConditions.MatchingFilters
 * @param {('All'|'AtLeastOne')} searchConditions.MatchingFilters.Condition
 * @param {Array<number>} searchConditions.MatchingFilters.Filters
 * @param {string} searchConditions.UnsubscriptionType
 * @param {string} searchConditions.UnsubscriptionSubType
 * @param {number} searchConditions.UnsubscriptionMessage
 * @param {string} searchConditions.Email
 * @param {('EXACT'|'CONTAINS'|'STARTWITH'|'ENDWITH')} searchConditions.EmailMatchType
 * @param {string} searchConditions.MobilePrefix
 * @param {string} searchConditions.MobileNumber
 *
 */
export const beRecipientSearchForRecipients = (
  idList,
  params,
  searchConditions
) => {
  const url = endpoints.searchForRecipients(idList, params)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(searchConditions),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const beRecipientGetRecipient = idRecipient => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRecipient(idRecipient)
  }).then(extractApiData)
}

export const beRecipientGetDynamicFileds = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getDynamicFileds()
  }).then(extractApiData)
}

export const beRecipientGetDynamicFiledsListValue = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getDynamicFiledsListValue(idList)
  }).then(extractApiData)
}

export const beRecipientGetTestsDefault = idList => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getTestsDefault(idList)
  }).then(extractApiData)
}

export const beRecipientLazySearch = (idList, params, searchConditions) => {
  const url = endpoints.lazySearch(idList, params)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(searchConditions),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}

export const GROUPS_SEARCH_TYPE_EQUALTO = 'EQUALTO'
export const GROUPS_SEARCH_TYPE_ECONTAINS = 'CONTAINS'
export const CHANNEL_TYPE_EMAIL = 'Email'
export const SUBSCRIPTION_TYPE_SUBSCRIBED = 'Subscribed'
export const HAS_RECIPIENTS = 'HASRECIPIENTS'
export const HAS_EMAIL_RECIPIENTS = 'HASEMAILRECIPIENTS'
export const HAS_SMS_RECIPIENTS = 'HASSMSRECIPIENTS'

export const GROUP_TYPE_TEST = 'Test'
